const {cs}             = require("../../../react/chain-services");
const {fragments}      = require("../../../react/fragments");
const {keyCombo}       = require("../../../react/key-combo");
const {GlobalEvent}    = require("../../../react/global-event");
const {Static2}        = require("../../../react/static-2");
const {getELoc}        = require("../../../ui-components/browser/get-e-loc");
const {GlobalKeyDown2} = require("../../../ui-components/browser/global-key-down-2");

const TrackMousePos = ({disabled, key, action}) => cs(
    ["pos", (_, next) => Static2({next})],
    ({pos}) => fragments(
        GlobalEvent({
            eventName: "mousemove",
            action: (e) => {
                pos.set(getELoc(e));
            },
            useCapture: true,
        }),
        !disabled && GlobalKeyDown2({
            check: keyCombo(key),
            // check: keyCombo("alt+O"),
            action: async (e) => {
                e.preventDefault();
                const p1 = pos.get();
                if (!p1) {
                    console.log("No mouse pos");
                    return;
                }
                action(p1);
            },
        }),
    ),
);
exports.TrackMousePos = TrackMousePos;
